var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "dropdown-item" },
    [
      _vm.multiple && (!_vm.level || _vm.isAboveLevel)
        ? [
            !_vm.isSelected ? _c("checkbox-empty") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected ? _c("checkbox-selected") : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.labelPrefix
        ? _c(
            "span",
            {
              class: {
                indented: _vm.multiple && _vm.level && !_vm.isAboveLevel,
              },
            },
            [_vm._v(_vm._s(_vm.optionTitle) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.labelPrefix
        ? _c(
            "span",
            {
              class: {
                indented: _vm.multiple && _vm.level && !_vm.isAboveLevel,
              },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.labelPrefix) + "\n    "),
              _c("chevron-right"),
              _vm._v("\n    " + _vm._s(_vm.optionTitle) + "\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.actionText
        ? _c("span", { staticClass: "secondary" }, [
            _vm._v(_vm._s(_vm.actionText) + "\n  "),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }